import { createContext, useContext, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const StableNavigateContext = createContext(null);

const StableNavigateContextProvider = ({ children }) => {
  const navigate = useNavigate();
  const navigateRef = useRef(navigate);

  useEffect(() => {
    navigateRef.current = navigate; // Keep reference updated
  }, [navigate]);

  return (
    <StableNavigateContext.Provider value={navigateRef}>
      {children}
    </StableNavigateContext.Provider>
  );
};

const useStableNavigate = () => {
  const navigateRef = useContext(StableNavigateContext);

  if (!navigateRef || !navigateRef.current) {
    throw new Error("StableNavigateContext is not initialized. Ensure the component is wrapped with <StableNavigateContextProvider>");
  }

  return navigateRef.current;
};

export {
  StableNavigateContext,
  StableNavigateContextProvider,
  useStableNavigate
};
